// The tokens every piece of the Database Management screen shares.
//
// Colour never carries a state on its own here — a chip pairs its tone with a
// word and an icon — so these hold only the tone index and the shapes, and each
// component supplies the word.

// Badge colorIndex map (see components/ui/Badge.jsx).
export const TONE = { emerald: 3, amber: 2, rose: 1, slate: 8, violet: 4 };

// One pill shape for every fleet-level control, so a safe action and a
// destructive one differ by colour alone, never by size.
export const PILL =
    "rounded-full px-3 py-2 text-[11px] flex items-center gap-1 disabled:opacity-50 disabled:cursor-not-allowed";
export const PILL_NEUTRAL = `${PILL} bg-background-icon text-text-primary hover:bg-background-icon/60`;
export const PILL_PRIMARY = `${PILL} bg-button-secondary text-text-base hover:bg-button-secondary/85`;
export const PILL_DANGER = `${PILL} bg-tone-rose-soft text-tone-rose border border-tone-rose/30 hover:bg-tone-rose/15`;

// `bg-tone-* text-text-invert` is the only solid-tone pair that clears 4.5:1 in
// both themes: light tones are dark fills under white text, dark tones are
// bright fills under black text, and `--color-text-invert` flips with them.
export const SOLID_DANGER = "bg-tone-rose text-text-invert hover:bg-tone-rose/90";
export const SOLID_WARNING = "bg-tone-amber text-text-invert hover:bg-tone-amber/90";

// The type-this-to-confirm field the modals wear. Focus state comes from the
// `Input` primitive; this only sets the tighter padding these modals use.
export const CONFIRM_INPUT_CLASS =
    "w-full rounded-lg px-3 py-2 text-sm bg-background-form/40 disabled:opacity-50 disabled:cursor-not-allowed";

// The bordered, row-divided list every detail panel on this screen renders into
// — table lists, operation lists, permission diffs, schema differences. Six
// components were carrying the same four class names; a change to how a list
// looks now happens once, the same way `PILL` above already works.
export const DETAIL_LIST =
    "rounded-md border border-border-primary divide-y divide-border-primary";
